import { AxiosResponse } from 'axios';
import { LoginResponse } from '../interfaces/Auth.interface';
import ApiClient from './ApiClient';
import { fetchCsrfCookie } from './csrf';
import { getOrCreateDeviceToken } from '@/utils/deviceTrust';

let apiClient: ApiClient;

const getApiClient = () => {
  if (!apiClient) {
    apiClient = new ApiClient();
  }
  return apiClient;
};

export const authApi = {
  verifyUser: async (email: string): Promise<AxiosResponse<LoginResponse>> => {
    await fetchCsrfCookie();
    return getApiClient().post(
      `/verify-user`,
      { email },
      {
        headers: {
          'X-Device-Token': getOrCreateDeviceToken()
        }
      }
    );
  },

  establishPassportWebSession: async (): Promise<AxiosResponse> => {
    await fetchCsrfCookie();
    return getApiClient().post(`/passport/web-session`, {});
  },

  destroyPassportWebSession: async (): Promise<AxiosResponse> => {
    await fetchCsrfCookie();
    return getApiClient().delete(`/passport/web-session`);
  },

  logout: async (): Promise<AxiosResponse> => {
    await fetchCsrfCookie();
    return getApiClient().post(`/logout`, {});
  }
};
